<template>
  <div class="container-fluid mb-5">
    <!----- Header Title ----->
    <div class="row content-header">
      <div class="col-md-6">
        <div>
          <h3 class="page-title mb-1">
            {{ this.$route.meta.title }}
          </h3>
        </div>
        <div class="breadcrumb-container">
          <ul class="uk-breadcrumb">
            <li><span>Anywhere</span></li>
            <li><a href="">{{ this.$route.meta.title }}</a></li>
          </ul>
        </div>
      </div>
      <div class="col-md-6 relative uk-animation-slide-bottom-small">
        <div class="pt-5 mt-3" style="float: right;">
          <div class="mb-3 text-right">
            <router-link :to="'/gallery/bmV3'">
              <a class="outline-btn" style="height: 40px;"><i class="fas fa-plus mr-2"></i>Add</a>
            </router-link>
          </div>
        </div>
        <div class="pb-3 pl-2 pt-5 mt-3" style="float: right;">
          <div class="form-group search notify-btn mb-1">
            <input type="text" name="keyword" placeholder="Search for..." class="form-control shadow-none border-0" />
            <div class="input-group-prepend">
              <span class="input-group-text border-0 bg-transparent">
                <button type="submit" class="bg-transparent border-0"><i class="far fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table class="table data-table table-round table-hover uk-animation-slide-bottom-small">
            <thead>
              <tr>
                <th scope="col" >Category</th>
                <th scope="col">Category</th>
                <th scope="col">Name</th>

               

                <th scope="col" class="text-center">Status</th>
                <th scope="col" class="blankhead" width="150px"></th>
                <th scope="col" class="blankhead" width="150px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, index) in galleryList" :key="index">
                <td v-if="list.tago">
                  <a :href="list.image" target="_blank">
                    <img :src="list.image" class="uk-border-circle" height="100px">
                  </a> </td>
                <td v-if="!list.tago">
                <a :href="list.image" target="_blank">
                  <img :src="censoredimg" class="uk-border-circle" height="100px">
                </a> </td>

                <td>{{ list.category }}</td>
                

                <td> {{ list.name }}</td>

                <td class="text-center">
                  <!-- <label class="switch">
                    <input type="checkbox" v-model="list.tago" checked disabled/>
                    <span class="slider round"></span>
                  </label> -->
                </td>
                <td class="text-right">
                  <div class="action-btn d-flex justify-content-end">
                    <router-link :to="'gallery/' + encode(list.key)">
                      <a class="edit-btn"><i class="fal fa-edit"></i></a>
                    </router-link>

                    <a class="del-btn" v-on:click="del_method(list)"><i class="fal fa-trash-alt"></i></a>
                   
                  </div>
                </td>
                <td class="text-center">
                  <a :href="list.image" target="_blank">
                    Preview
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
import FirebaseCrud from ".././Firebase/services/FirebaseCrud";
import Common from ".././Firebase/services/Common";

export default {
  name: "gallery",
  data() {
    return {
      galleryList: [],
      categoryList: [],
      censoredimg:'https://firebasestorage.googleapis.com/v0/b/zz-sw-tools.appspot.com/o/Images%2Fgallery%2F1666625775009-zzz.png?alt=media&token=d76c09a0-9a9e-4a8e-b0b8-f07fb24e8a80'
    };
  },
  methods: {
    onDataChange(items) {
      this.galleryList = [];
      this.categoryList = [];
      items.forEach((item) => {
        let key = item.key;
        this.categoryList.push(key)
        FirebaseCrud.getgalleryContent(key).on("value", this.onCategoryChange);
      });
    },
    onCategoryChange(items) {
      items.forEach((item) => {
        let key = item.key;
        let larawan = item.val()
        console.log(larawan)
        this.galleryList.push({
          key: larawan.category + "/" + key,
          category: larawan.category,
          image: larawan.image,
          name: larawan.name,
          update_at: larawan.update_at,
          hidden: larawan.hidden,
          tago:larawan.tago
        });
      });
    },
    encode(id) {
      return btoa(id)
    },
    del_method(gallery) {
      UIkit.modal.confirm('Do you want to delete : ' + gallery.name + ' ? ').then(
        function () {
          let path = "/gallery/content/" + gallery.key
          FirebaseCrud.deleteContent(path)
          location.href = "/gallery"
          console.log('Confirmed.')
        },
        function () {
          console.log('Rejected.')
        },
      )
      let path = "/gallery/content/" + key
      console.log(path)

    }
  },
  mounted() {
    FirebaseCrud.checkUser()
    const encryptedText = this.$CryptoJS.AES.encrypt("", atob("WlpKTTIwMjI=")).toString()
    console.log(encryptedText)


    FirebaseCrud.getContent("/gallery/content/").on("value", this.onDataChange);
  },
  beforeUnmount() {
    FirebaseCrud.getContent("/gallery/content/").off("value", this.onDataChange);
  }
};
</script>

<style scoped>
.card-footer {
  text-align: right;
  position: relative;
  background: #fff;
}

.pagination {
  top: 20px;
  position: absolute;
  right: 0px;
  align-content: flex-end;
  text-align: end;
}

.table td:nth-child(2) {
  text-transform: capitalize;
}
</style>